import * as types from './actionTypes';

export function getAdminConfigRequest() {
  return {
    type: types.GET_ADMIN_CONFIG_REQUEST,
  };
}

export function getAdminConfigSuccess(data) {
  return {
    type: types.GET_ADMIN_CONFIG_SUCCESS,
    data,
  };
}

export function getAdminConfigFail(error) {
  return {
    type: types.GET_ADMIN_CONFIG_FAIL,
    error,
  };
}

export function exportQuotationsStatsRequest(params) {
  return {
    type: types.EXPORT_QUOTATIONS_STATS_REQUEST,
    params,
  };
}

export function exportQuotationsStatsSuccess({ data, params }) {
  return {
    type: types.EXPORT_QUOTATIONS_STATS_SUCCESS,
    data,
    params,
  };
}

export function exportQuotationsStatsFail(error) {
  return {
    type: types.EXPORT_QUOTATIONS_STATS_FAIL,
    error,
  };
}
